"use client";

import React, { useEffect } from "react";
import { twMerge } from "tailwind-merge";
import { useState } from "react";
import { format } from "date-fns";
import useHeader from "@/functions/useHeader";
import HeaderDompetDigital from "./_component/header";
import currency from "@/functions/currency";
import TrendKomisi from "./_component/trend-komisi";
import History from "./_component/history-comission";
import {
  getReportKomisi,
  getReportWallet,
  getReportWithdraw
} from "@/functions/databaseData";
import HistoryComission from "./_component/history-comission";
import HistoryWallet from "./_component/history-wallet";
import { CircleDollarSignIcon, PlusCircleIcon } from "lucide-react";
import Button from "@/components/atom/Button";
import useModal from "@/functions/useModal";
import ContainerModal from "@/components/sub-atom/ContainerModal";
import Topup from "./_component/top-up";
import Withdrawel from "./_component/withdrawel";
import HistoryWithdraw from "./_component/history-withdraw";
import { dompetDigitalTopUpDriverJS, dompetDigitalWithdrawDriverJS } from "@/functions/useDriveJs";

const formatFieldKomisi = [
  {
    label: "Komisi hari ini",
    key: "price_comision_today"
  },
  {
    label: "Total Komisi",
    key: "last_mount"
  },
  {
    label: "Total Transaksi",
    key: "price_transaction_comission"
  }
];

const formatFieldWallet = [
  // {
  //   label: "Saldo Digunakan",
  //   key: "balance_used"
  // },
  {
    label: "Total Saldo",
    key: "remaining_balance"
  }
];

export default function DompetDigital({ paddingStyle }) {
  const { session } = useHeader();
  const { openModal, closeModal } = useModal();

  const [listKomisiCard, setListKomisiCard] = useState([]);
  const [listWalletCard, setListWalletCard] = useState([]);
  const [typeModal, setTypeModal] = useState("");
  const [datasWallet, setDatasWallet] = useState();
  const [datasWithdraw, setDatasWithdraw] = useState();
  const [date, setDate] = useState({
    date_from: "", // format yyyy-mm-dd
    date_until: "",
    date_numeric: 30 // format number
  });

  async function getReportDashboard(body) {
    try {
      let resWallet = await getReportWallet({
        token: session?.user?.token,
        mitra_id: session?.user?.data?.mitra_id,
        date_from: !body?.date_from
          ? ""
          : format(body?.date_from, "yyyy-MM-dd"),
        date_until: !body?.date_until
          ? ""
          : format(body?.date_until, "yyyy-MM-dd"),
        date_numeric: body?.date_numeric
      });

      setDate(body);

      if ((resWallet?.error || resWallet?.error?.message)?.length > 0)
        throw new Error(resWallet?.error || resWallet?.error?.message);

      formatFieldWallet.forEach((a) => {
        a.value = resWallet[a?.key] ?? 0;
      });
      setDatasWallet(resWallet);
      setListWalletCard(formatFieldWallet);
    } catch (error) {
      console.log(error);
    }
  }

  async function getHistoryWithdraw(body) {
    let resWithdraw = await getReportWithdraw({
      token: session?.user?.token,
      status: body?.status || "",
      mitra_id: session?.user?.data?.mitra_id,
      date_from: !body?.date_from ? "" : format(body?.date_from, "yyyy-MM-dd"),
      date_until: !body?.date_until
        ? ""
        : format(body?.date_until, "yyyy-MM-dd"),
      date_numeric: body?.date_numeric
    });
    setDatasWithdraw(resWithdraw);
  }

  useEffect(() => {
    closeModal()
    dompetDigitalTopUpDriverJS();
    getReportDashboard({ ...date, getFirst: true });
    getHistoryWithdraw({ ...date });
  }, []);

  return (
    <React.Fragment>
      <div className={twMerge(paddingStyle, "flex flex-col gap-8")}>
        <HeaderDompetDigital getReportDashboard={getReportDashboard} />
        <div className="flex flex-col gap-4">
          {/* Wallet Activity */}
          <div
            className=" bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8
              flex flex-col gap-6
              overflow-hidden overflow-x-scroll
              "
          >
            <div className="flex md:flex-row flex-col justify-between md:items-center md:gap-2 gap-4 border-b border-b-greyscaleGON-200 pb-4">
              <div className="flex flex-col gap-2">
                <p className="subheading-semiBold text-greyscaleGON-700">
                  Wallet Activity
                </p>
                <p className="p2-regular sm:p1-regular text-greyscaleGON-400">
                  History Wallet kamu dalam{" "}
                  {!date?.date_numeric
                    ? !date?.date_until
                      ? format(
                          !date?.date_from ? new Date() : date?.date_from,
                          "PPP"
                        )
                      : `${format(date?.date_from, "PPP")} - ${format(
                          date?.date_until,
                          "PPP"
                        )}`
                    : `dalam ${date?.date_numeric} hari terakhir`}
                </p>
              </div>
              <div className="flex w-full md:justify-end">
                <div className="flex md:w-fit w-full md:flex-row flex-col md:items-center gap-2">
                  <Button
                    icon={{
                      left: (props) => <CircleDollarSignIcon {...props} />
                    }}
                    id="highlight-me-topup"
                    size="small"
                    label="Top Up"
                    onClick={() => {
                      setTypeModal("top-up");
                      openModal();
                      dompetDigitalTopUpDriverJS(1);
                    }}
                  />
                  <Button
                    icon={{
                      left: (props) => <CircleDollarSignIcon {...props} />
                    }}
                    id="highlight-me-withdraw"
                    size="small"
                    variants="outline"
                    label="Tarik Wallet"
                    onClick={() => {
                      setTypeModal("withdrawel");
                      openModal();
                      dompetDigitalWithdrawDriverJS(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="gap-4 justify-between items-center
        grid grid-cols-2 xs:grid-cols-3
        "
            >
              {listWalletCard?.map((item, index) => {
                return (
                  <div key={index} className="flex gap-4 w-full items-center">
                    <div className="flex flex-col gap-1 sm:gap-2">
                      <p className="p2-medium sm:p1-medium text-greyscaleGON-700">
                        {item.label}
                      </p>
                      <p className="h5-medium sm:h4-medium text-primaryGON-300">
                        {currency(item?.value)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="grid xl:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
            <HistoryWallet datas={datasWallet?.resp_history} />
            <HistoryWithdraw
              datas={datasWithdraw}
              getHistoryWithdraw={getHistoryWithdraw}
            />
          </div>
        </div>
      </div>

      <ContainerModal className={twMerge("xs:p-8 p-4 max-w-[552px]")}>
        {typeModal == "withdrawel" ? <Withdrawel /> : <Topup />}
      </ContainerModal>
    </React.Fragment>
  );
}
